import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "reset-password-group" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"side\"><div class=\"side-text-wrap\"><div class=\"welcome-text\">WELCOME BACK</div><a href=\"/\"><img class=\"logo\" src=\"/images/auth/login-logo.png\" alt=\"\"></a></div></div>", 1)
const _hoisted_3 = { class: "form-container" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "mobile-logo",
    src: "/images/auth/login-logo.png",
    alt: ""
  })
], -1)
const _hoisted_5 = { class: "text-dark auth-language-dropdown" }
const _hoisted_6 = { class: "title" }
const _hoisted_7 = { class: "mb-6" }
const _hoisted_8 = { class: "label" }
const _hoisted_9 = { class: "fv-plugins-message-container" }
const _hoisted_10 = { class: "fv-help-block" }
const _hoisted_11 = { class: "mb-6" }
const _hoisted_12 = { class: "d-flex justify-content-between" }
const _hoisted_13 = { class: "label" }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { key: 1 }
const _hoisted_16 = { class: "fv-plugins-message-container" }
const _hoisted_17 = { class: "fv-help-block" }
const _hoisted_18 = { class: "mb-6" }
const _hoisted_19 = { class: "d-flex justify-content-between" }
const _hoisted_20 = { class: "label" }
const _hoisted_21 = { key: 0 }
const _hoisted_22 = { key: 1 }
const _hoisted_23 = { class: "fv-plugins-message-container" }
const _hoisted_24 = { class: "fv-help-block" }
const _hoisted_25 = { class: "indicator-label" }
const _hoisted_26 = { class: "indicator-progress" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)
const _hoisted_28 = { class: "msg_1" }

import axios from "axios";
import * as Yup from "yup";
import { useStore } from "@/store";
import { ref, onMounted } from "vue";
import { Actions } from "@/store/enums/StoreEnums";
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import { ErrorMessage, Field, Form } from "vee-validate";
import LanguageDropdown from "../../components/LanguageDropdown.vue";
import i18n from "@/core/plugins/i18n";
import { useRouter } from "vue-router";


export default /*#__PURE__*/_defineComponent({
  __name: 'ResetPassword',
  props: {
  code: { type: String, required: true },
},
  setup(__props) {

const props = __props;

const { t } = i18n.global;
const store = useStore();
const passwordShow_1 = ref(false);
const passwordShow_2 = ref(false);
const submitButton = ref<HTMLButtonElement | null>(null);
const router = useRouter();



onMounted(() => {
  store.dispatch(Actions.REMOVE_BODY_CLASSNAME, "page-loading");
});

const validationSchema = Yup.object().shape({
  email: Yup.string().email().required().label("Email"),
  password: Yup.string()
    .min(8, t("error.signup_ps_8"))
    .matches(/[a-z]/, t("error.signup_ps_lower"))
    .matches(/[A-Z]/, t("error.signup_ps_upper"))
    .matches(/\d/, t("error.signup_ps_number"))
    .matches(/[!@#$%^&*(),.?":{}|<>]/, t("error.signup_ps_symbol"))
    .required(t("error.signup_ps_require")),
  confirmPassword: Yup.string()
    .oneOf([Yup.ref("password"), null], t("error.signup_ps_match"))
    .required(t("error.signup_ps_require")),
});

//form submit function
const onResetPassword = async (values) => {
  await store.dispatch(Actions.LOGOUT);

  if (!submitButton.value) {
    return;
  }

  submitButton.value.disabled = true;
  submitButton.value.setAttribute("data-kt-indicator", "on");

  try {
    await axios.post("/api/v1/auth/password/reset", {
      email: values.email,
      password: values.password,
      code: props.code,
    });

    Swal.fire({
      text: "Your password has been reset successfully!",
      icon: "success",
      buttonsStyling: false,
      confirmButtonText: "Ok!",
      customClass: {
        confirmButton: "btn fw-semobold btn-light-primary",
      },
    })
      .then(() => store.dispatch(Actions.LOGOUT))
      .then(() => router.push({ name: "sign-in" }));
  } catch (error) {
    Swal.fire({
      text: error,
      icon: "error",
      buttonsStyling: false,
      confirmButtonText: t("error.unknown"),
      customClass: {
        confirmButton: "btn fw-semobold btn-light-danger",
      },
    });
    // console.error(error);
  }

  submitButton.value.disabled = false;
  submitButton.value.setAttribute("data-kt-indicator", "off");
};

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _createVNode(LanguageDropdown)
      ]),
      _createVNode(_unref(Form), {
        class: "reset-form",
        onSubmit: onResetPassword,
        "validation-schema": _unref(validationSchema)
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t("title.startResetPassword")), 1),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("label", _hoisted_8, _toDisplayString(_ctx.$t("fields.email")), 1),
            _createVNode(_unref(Field), {
              tabindex: "1",
              class: "mt-1 form-control form-control-lg form-control-solid",
              type: "text",
              name: "email",
              autocomplete: "off"
            }),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createVNode(_unref(ErrorMessage), { name: "email" })
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("label", _hoisted_13, _toDisplayString(_ctx.$t("fields.newPassword")), 1),
              _createElementVNode("div", null, [
                _createElementVNode("i", {
                  class: _normalizeClass(["fa-solid fa-lg eye-icon", passwordShow_1.value ? 'fa-eye-slash' : 'fa-eye']),
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (passwordShow_1.value = !passwordShow_1.value))
                }, null, 2),
                (passwordShow_1.value)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(_ctx.$t("action.hide")), 1))
                  : (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(_ctx.$t("action.show")), 1))
              ])
            ]),
            _createVNode(_unref(Field), {
              tabindex: "2",
              class: "mt-1 form-control form-control-lg form-control-solid",
              type: passwordShow_1.value ? 'text' : 'password',
              name: "password",
              autocomplete: "off"
            }, null, 8, ["type"]),
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                _createVNode(_unref(ErrorMessage), { name: "password" })
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("label", _hoisted_20, _toDisplayString(_ctx.$t("fields.confirmPassword")), 1),
              _createElementVNode("div", null, [
                _createElementVNode("i", {
                  class: _normalizeClass(["fa-solid fa-lg eye-icon", passwordShow_2.value ? 'fa-eye-slash' : 'fa-eye']),
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (passwordShow_2.value = !passwordShow_2.value))
                }, null, 2),
                (passwordShow_2.value)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_21, _toDisplayString(_ctx.$t("action.hide")), 1))
                  : (_openBlock(), _createElementBlock("span", _hoisted_22, _toDisplayString(_ctx.$t("action.show")), 1))
              ])
            ]),
            _createVNode(_unref(Field), {
              tabindex: "2",
              class: "mt-1 form-control form-control-lg form-control-solid",
              type: passwordShow_2.value ? 'text' : 'password',
              name: "confirmPassword",
              autocomplete: "off"
            }, null, 8, ["type"]),
            _createElementVNode("div", _hoisted_23, [
              _createElementVNode("div", _hoisted_24, [
                _createVNode(_unref(ErrorMessage), { name: "confirmPassword" })
              ])
            ])
          ]),
          _createElementVNode("div", null, [
            _createElementVNode("button", {
              tabindex: "3",
              type: "submit",
              ref_key: "submitButton",
              ref: submitButton,
              id: "kt_sign_in_submit",
              class: "btn btn-lg w-100 loginBtn"
            }, [
              _createElementVNode("span", _hoisted_25, _toDisplayString(_ctx.$t("action.reset")), 1),
              _createElementVNode("span", _hoisted_26, [
                _createTextVNode(_toDisplayString(_ctx.$t("action.pleaseWait")) + " ", 1),
                _hoisted_27
              ])
            ], 512),
            _createElementVNode("div", _hoisted_28, [
              _createTextVNode(_toDisplayString(_ctx.$t("action.backTo")) + " ", 1),
              _createVNode(_component_router_link, { to: "/sign-in" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t("action.login")), 1)
                ]),
                _: 1
              })
            ])
          ])
        ]),
        _: 1
      }, 8, ["validation-schema"])
    ])
  ]))
}
}

})